<script>
  export let fill = "#ffffff";
  export let size = 40;
</script>

<svg
  width={size}
  height={size}
  {fill}
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  version="1.1"
  x="0px"
  y="0px"
  viewBox="0 0 100 100"
  style="enable-background:new 0 0 100 100;"
  xml:space="preserve"
  stroke="white"
  ><g
    ><path
      class="st0"
      d="M71.5,41.2c-1.9,0-3.5,1.5-3.5,3.3v1.3c0-3.7-3.1-6.7-7-6.7c-1.9,0-3.5,1.5-3.5,3.3v1.3c0-3.7-3.1-6.7-7-6.7   c-1.9,0-3.5,1.5-3.5,3.3v1.3l-0.1-1.4l-1.1-17.1c-0.2-2.3-2.1-4.1-4.4-4.1s-4.1,1.9-4.1,4.1v16.5v20.6l-3.7-5.6   c-2.5-3.8-7.2-5.4-11.3-3.4c-1,0.5-1.2,1.6-0.7,2.6l5.1,13.1c0.8,2.1,2.9,5,4.5,6.5c0,0,10.2,8.4,10.2,11.6v4h16.5h8.2h4v-4   c0-3.2,6.2-13.1,6.2-13.1c1.2-1.9,2.1-5.4,2.1-7.6V47.9C78.5,44.2,75.4,41.2,71.5,41.2z"
    /><path
      d="M33.8,32.5c-6.3-6.7-2.2-18.1,7.1-19c10.3-1.1,16,10.8,9.8,18.7c-1,1.3,0.8,3,1.8,1.8c7.3-9.3,1.6-23.7-11-23.1   C29.6,11.4,24.1,25.8,32,34.2C33.1,35.4,34.9,33.6,33.8,32.5z"
    /></g
  ></svg
>
